import request from '@/utils/request'

export function getAuthorizeUrl() {
  return request.get('/auth/wecom/authorize-url')
}

export function loginByWeComCode(code) {
  return request.post('/auth/wecom/login', { code })
}

export function loginByBackendAuth(payload = {}) {
  const url = process.env.VUE_APP_BACKEND_AUTH_PATH || '/auth/login'
  const method = (process.env.VUE_APP_BACKEND_AUTH_METHOD || 'post').toLowerCase()
  if (method === 'get') {
    return request.get(url, { params: payload })
  }
  return request({
    url,
    method,
    data: payload
  })
}

export function refreshToken(refreshToken) {
  return request.post('/auth/refresh-token', { refreshToken })
}

export function getUserInfo() {
  return request.get('/auth/user-info')
}

export function logout() {
  return request.post('/auth/logout')
}
